(function () {

  // ─── Shared cart state ───────────────────────────────────────────
  let cartVariantIds = new Set();

  function getCartSectionId() {
    return document.querySelector('cart-items-component[data-drawer]')?.dataset.sectionId || null;
  }

  // ─── Button states ───────────────────────────────────────────────
  function updateAllButtons() {
    document.querySelectorAll('.product-cross-sell__add').forEach(btn => {
      btn.classList.toggle('is-active', cartVariantIds.has(String(btn.dataset.variantId)));
    });
  }

  // ─── Cart bubble count ───────────────────────────────────────────
  function updateCartCount(count) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(el => {
      el.textContent = count;
    });
    document.querySelectorAll('.cart-bubble .visually-hidden:not(.wishlist-bubble)').forEach(el => {
      el.textContent = `Total items in cart: ${count}`;
    });
  }

  // ─── Buy with Addons UI ──────────────────────────────────────────
  function updateAddonButtonUI() {
    if (!window.pairedProductsData?.length) return;

    const buyNowContainer = document.querySelector('.buy-buttons-block');
    if (!buyNowContainer) return;

    const buyNowButton = buyNowContainer.querySelector('.shopify-payment-button__button');
    let addonBtn = buyNowContainer.querySelector('.buy-with-addons-button');

    const matchedProducts = window.pairedProductsData.filter(p =>
      cartVariantIds.has(String(p.id))
    );

    if (matchedProducts.length > 0) {
      if (buyNowButton) buyNowButton.style.display = 'none';

      if (!addonBtn) {
        addonBtn = document.createElement('button');
        addonBtn.className = 'buy-with-addons-button button';
        addonBtn.type = 'button';
        addonBtn.style.width = '100%';

        const wrapper = document.createElement('div');
        wrapper.className = 'addons-wrapper';

        const text = document.createElement('span');
        text.className = 'addons-title';
        text.textContent = 'Buy with Addons';

        const imageWrapper = document.createElement('div');
        imageWrapper.className = 'addons-images';

        wrapper.appendChild(text);
        wrapper.appendChild(imageWrapper);
        addonBtn.appendChild(wrapper);
        // ← no addEventListener here, handled by delegation below

        buyNowContainer.appendChild(addonBtn);
      }

      // ── Sync images without touching existing ones ──
      const imageWrapper = addonBtn.querySelector('.addons-images');

      const existingIds = new Set(
        [...imageWrapper.querySelectorAll('.addons-circle')]
          .map(img => img.dataset.productId)
      );

      imageWrapper.querySelectorAll('.addons-circle').forEach(img => {
        if (!matchedProducts.find(p => String(p.id) === img.dataset.productId)) {
          img.remove();
        }
      });

      matchedProducts.slice(0, 3).forEach(product => {
        if (existingIds.has(String(product.id))) return;

        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.title || '';
        img.className = 'addons-circle addons-circle--new';
        img.dataset.productId = String(product.id);

        img.addEventListener('animationend', () => {
          img.classList.remove('addons-circle--new');
        }, { once: true });

        imageWrapper.appendChild(img);
      });

    } else {
      if (buyNowButton) buyNowButton.style.display = '';
      if (addonBtn) addonBtn.remove();
    }
  }

  // ─── Sync cart state ─────────────────────────────────────────────
  async function syncCart() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      cartVariantIds = new Set(cart.items.map(i => String(i.variant_id)));
      updateAllButtons();
      updateCartCount(cart.item_count);
      updateAddonButtonUI();
    } catch (e) {
      console.error('Product cross-sell sync error:', e);
    }
  }

  // ─── Refresh cart drawer ─────────────────────────────────────────
  async function refreshCartDrawer(cart) {
    const sectionId = getCartSectionId();
    if (!sectionId) return;

    try {
      const sectionsData = await fetch(`${window.location.pathname}?sections=${sectionId}`)
        .then(r => r.json());

      const drawer = document.querySelector('cart-drawer-component');
      const hadAutoOpen = drawer?.hasAttribute('auto-open');
      if (hadAutoOpen) drawer.removeAttribute('auto-open');

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'product-cross-sell',
          data: {
            sections: sectionsData,
            itemCount: cart.item_count,
            source: 'product-cross-sell'
          }
        }
      }));

      if (hadAutoOpen) drawer.setAttribute('auto-open', '');

    } catch (e) {
      console.error('Drawer refresh error:', e);
    }
  }

  // ─── Cross-sell button click handler ────────────────────────────
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.product-cross-sell__add');
    if (!btn || btn.disabled) return;

    const variantId = String(btn.dataset.variantId);
    const wasActive = btn.classList.contains('is-active');

    btn.classList.add('is-loading');
    btn.disabled = true;

    try {
      await fetch(wasActive ? '/cart/change.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(wasActive
          ? { id: variantId, quantity: 0 }
          : { id: variantId, quantity: 1 }
        )
      });

      wasActive ? cartVariantIds.delete(variantId) : cartVariantIds.add(variantId);

      const cart = await fetch('/cart.js').then(r => r.json());
      cartVariantIds = new Set(cart.items.map(i => String(i.variant_id)));

      btn.classList.remove('is-loading');

      requestAnimationFrame(() => {
        btn.classList.toggle('is-active', !wasActive);
        updateAllButtons();
        updateCartCount(cart.item_count);
        updateAddonButtonUI();
      });

      await refreshCartDrawer(cart);

    } catch (e) {
      console.error('Product cross-sell cart error:', e);
    } finally {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  });

  // ─── Buy with Addons click handler (delegated) ──────────────────
  document.addEventListener('click', async function (e) {
    if (!e.target.closest('.buy-with-addons-button')) return;

    const variantInput = document.querySelector('[data-type="add-to-cart-form"] input[name="id"]');
    if (!variantInput) {
      window.location.href = '/cart';
      return;
    }

    const qtyInput = document.querySelector('quantity-input-component input')
      || document.querySelector('[data-type="add-to-cart-form"] input[name="quantity"]');
    const quantity = parseInt(qtyInput?.value, 10) || 1;
    const variantId = variantInput.value;

    try {
      if (!cartVariantIds.has(variantId)) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });
      }
    } catch (e) {
      console.error('Buy with addons - failed to add main product:', e);
    }

    window.location.href = '/cart';
  });

  // ─── External cart change listener ──────────────────────────────
  document.addEventListener('cart:update', (e) => {
    if (e.detail?.data?.source === 'product-cross-sell') return;
    syncCart();
  });

  // ─── Initial sync ────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCart);
  } else {
    syncCart();
  }

})();